import { FileDown } from "lucide-react";
import { motion } from "framer-motion";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { ProductCard, axiomEditions } from "../components/Products";
import { ProductCta, PageHero } from "../components/ProductPageShared";
import { usePageMeta } from "../hooks/usePageMeta";

export default function AxiomPage() {
  usePageMeta({
    title: "The AXIOM Family — Virtual Underwriter AI",
    description: "Six purpose-built editions of one underwriting brain — AXIOM for Underwriters, Lenders, Agents, and Attorneys are live in all 50 states, with National Agencies and Commercial coming soon.",
    path: "/axiom",
  });
  return (
    <main className="bg-navy min-h-screen" data-testid="axiom-page">
      <Navbar />
      <PageHero
        kicker="Product Family — AXIOM"
        title="The AXIOM family"
        accent="One underwriting brain. Every desk."
        sub="Six purpose-built editions of the same underwriting intelligence — the requirements to insure, cited and sourced correctly, framed for the professional using it. Four are live today, with two more on the way."
      />
      <section className="relative bg-navy pb-20 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <motion.a
            href="/assets/downloads/ask-axiom-outlook-flyer.pdf"
            download
            data-testid="axiom-outlook-flyer-link"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="group flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 border border-tech/40 bg-tech/10 px-6 py-5 mb-10 hover:border-tech-bright transition-colors duration-300"
          >
            <span className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-tech-bright shrink-0">New — AXIOM for Outlook</span>
            <span className="text-sm text-fog/70 flex-1">Ask AXIOM right from your inbox. Grab the one-page flyer to share with your team.</span>
            <span className="inline-flex items-center gap-2 font-mono-accent text-[11px] tracking-[0.22em] uppercase text-fog/60 group-hover:text-tech-bright transition-colors duration-300 shrink-0">
              <FileDown className="h-4 w-4" /> Download flyer (PDF)
            </span>
          </motion.a>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
            {axiomEditions.map((p, i) => (
              <ProductCard key={p.name} p={p} index={i} />
            ))}
          </div>
        </div>
      </section>
      <ProductCta heading="Ready to put AXIOM on your desk?" />
      <Footer />
    </main>
  );
}
